const cellPhoneRegExp = (): RegExp => {
  return /^(\+\d{1,3}\s?)?(\(?\d{1,4}\)?[\s.-]?)?\d{1,4}[\s.-]?\d{3,4}[\s.-]?\d{4}$/;
};

export default cellPhoneRegExp;
